import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '../models';

export const profileActions = createActionGroup({
    source: 'Profile',
    events: {
        // Dispatched by the session bridge - the profile has no request of its own.
        'Get Profile Success': props<{ payload: User }>(),
        // Clear
        Clear: emptyProps(),
    },
});
